export default {"src":"/_next/static/media/radial-progress-bar-complete.06afed9f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};